import {Directive, OnInit, OnDestroy, Output, EventEmitter, ElementRef} from '@angular/core';
import {fromEvent} from 'rxjs';

@Directive({
    selector: '[appClickOutside]'
})

export class ClickOutsideDirective implements OnInit, OnDestroy {
    @Output() clickOutside: EventEmitter<any> = new EventEmitter();

    private listening: boolean;

    preClickedElement;

    globalClick = fromEvent(document, 'click')
    .subscribe( (event: MouseEvent) => {
        this.onGlobalClick(event);
        this.listening = true;
    });

    constructor(private elRef: ElementRef) {
        this.listening = false;
    }

    ngOnInit() {
        this.preClickedElement = this.elRef.nativeElement;
    }

    ngOnDestroy() {
        this.listening = false;
        this.globalClick.unsubscribe();
    }

    onGlobalClick(event: MouseEvent) {
        if (event instanceof MouseEvent && this.listening === true) {
            if ( this.isDescendant(this.preClickedElement, event.target) === true ) {
                this.clickOutside.emit({
                    target: (event.target || null),
                    value: false
                });
            } else {
                this.clickOutside.emit({
                    target: (event.target || null),
                    value: true
                });
            }
        }
    }

    isDescendant(parent, child) {
        const all = parent.querySelectorAll('*');

        if (child === parent) {
            return true;
        }

        for (let i = 0; i < all.length; i++) {
            if (all[i] === child.parentNode || !child.parentNode) {
                return true;
            }
            if (all[i] === child) {
                return true;
            }
        }

        // let node = child;
        // while (node !== null) {
        //     if (node === parent) {
        //         return true;
        //     } else {
        //         node = node.parentNode;
        //     }
        // }
        return false;
    }
}
